module.exports = __webpack_public_path__ + "img/Rindang Sejahtera Finance.65643926.png";